import { enderecoStep, DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL } from '../../shared/enderecoSections';
import { mergeDadosRequerimentoConfig } from '../../../core/services/dadosRequerimentoConfigUtils';

const paymentConfig = {
  dynamicAmount: true,
  dynamicField: 'tipoDocumento',
  options: {
    'CARTAO_ESTAGIO': {
      name: '2ª Via do Cartão de Estágio',
      amount: 35.00,
      description: 'Segunda via do cartão de estágio'
    },
    'CARTAO_ADVOGADO': {
      name: '2ª Via do Cartão de Advogado',
      amount: 65.00,
      description: 'Segunda via do cartão de advogado'
    },
    'CARTEIRA_BROCHURA': {
      name: '2ª Via da Carteira (Brochura)',
      amount: 99.00,
      description: 'Segunda via da carteira de brochura'
    },
    'CARTAO_CARTEIRA': {
      name: '2ª Via do Cartão e Carteira',
      amount: 164.00,
      description: 'Segunda via do cartão e carteira completos'
    }
  }
};

const protocoloConfig = {
  modeloRequerimento: {
    field: paymentConfig.dynamicField,
    map: {
      CARTAO_ESTAGIO: '279',
      CARTAO_ADVOGADO: '298',
      CARTEIRA_BROCHURA: '299',
      CARTAO_CARTEIRA: '297'
    }
  },
  tiposAssunto: '824',
  tipoPedido: {
    field: paymentConfig.dynamicField,
    map: {
      CARTAO_ESTAGIO: '492',
      CARTAO_ADVOGADO: '494',
      CARTEIRA_BROCHURA: '495',
      CARTAO_CARTEIRA: '493'
    }
  }
};

// Confirmado ao vivo: os 4 modelos têm o mesmo shape (Nome/CPFCNPJ + endereço residencial, sem email).
const dadosRequerimentoConfig = mergeDadosRequerimentoConfig(
  {
    campos: [
      { field: 'nomeCompleto', campoNome: 'Nome' },
      { field: 'cpf', campoNome: 'CPFCNPJ' }
    ]
  },
  DADOS_REQUERIMENTO_ENDERECO_RESIDENCIAL
);

const tituloConfig = {
  tipoLancamentoId: {
    field: paymentConfig.dynamicField,
    map: {
      CARTAO_ESTAGIO: 44,
      CARTAO_ADVOGADO: 42,
      CARTEIRA_BROCHURA: 146,
      CARTAO_CARTEIRA: 147
    }
  },
  enderecoOrigem: 'residencial'
};

const pedidoSegundaViaConfig = {
  id: 'pedido_SegundaVia',
  nome: '2ª Via de Documentos Profissionais',
  categoria: 'pedidos',
  descricao: 'Solicitação de segunda via de carteira, cartão ou documento da OAB/MS',
  icon: 'FaIdCard',

  documentConfig: {
    required: [
      {
        id: 'requerimento', tipoDocumentoProcesso: 433,
        name: 'Requerimento',
        description: 'Requerimento preenchido e assinado digitalmente',
        required: true
      }
    ],

    optional: [
      {
        id: 'RG', tipoDocumentoProcesso: 533,
        name: 'RG',
        description: 'Cópia digitalizada do RG',
        required: false
      }
    ],

    conditional: [
      {
        id: 'boletimOcorrencia', tipoDocumentoProcesso: 100,
        name: 'Boletim de Ocorrência (B.O.)',
        description: 'Boletim de Ocorrência obrigatório para casos de Perda, Roubo ou Furto',
        conditional: true,
        required: true,
        dependsOn: { field: 'motivoPerda', value: 'SIM' }
      }
    ]
  },

  // Configuração de pagamento com valor dinâmico
  paymentConfig,
  protocoloConfig,
  tituloConfig,
  dadosRequerimentoConfig,

  steps: [
    {
      id: 'dados_pessoais',
      title: 'Dados Pessoais',
      sections: [
        {
          title: 'Identificação do Requerente',
          fields: [
            { 
              type: 'text', 
              name: 'nomeCompleto', 
              label: 'Nome completo', 
              required: true, 
              placeholder: 'Digite seu nome completo' 
            },
            { 
              type: 'cpf', 
              name: 'cpf', 
              label: 'CPF', 
              required: true 
            }
          ]
        },
        {
          title: 'Tipo de Documento Solicitado',
          fields: [
            {
              type: 'radio',
              name: 'tipoDocumento',
              label: 'Selecione o documento que deseja solicitar a 2ª via',
              required: true,
              options: [
                { 
                  value: 'CARTAO_ESTAGIO', 
                  label: '2ª Via do Cartão de Estágio - R$ 35,00',
                  description: 'Cartão de identificação para estagiários'
                },
                { 
                  value: 'CARTAO_ADVOGADO', 
                  label: '2ª Via do Cartão de Advogado - R$ 65,00',
                  description: 'Cartão de identificação para advogados'
                },
                { 
                  value: 'CARTEIRA_BROCHURA', 
                  label: '2ª Via da Carteira (Brochura) - R$ 99,00',
                  description: 'Carteira de brochura tradicional'
                },
                { 
                  value: 'CARTAO_CARTEIRA', 
                  label: '2ª Via do Cartão e Carteira - R$ 164,00',
                  description: 'Cartão e carteira completos'
                }
              ]
            }
          ]
        },
        {
          title: 'Motivo da Solicitação',
          fields: [
            {
              type: 'radio',
              name: 'motivoPerda',
              label: 'A solicitação é devido a Perda, Roubo ou Furto?',
              required: true,
              options: [
                { value: 'SIM', label: 'Sim - Perda, Roubo ou Furto' },
                { value: 'NAO', label: 'Não - Extravio, Dano ou outro motivo' }
              ]
            },
            {
              type: 'textarea',
              name: 'descricaoMotivo',
              label: 'Descreva detalhadamente o motivo da solicitação',
              required: true,
              placeholder: 'Explique as circunstâncias da perda, extravio, dano, etc.',
              rows: 3
            }
          ]
        }
      ]
    },
    enderecoStep({ autoCep: true }),
    {
      id: 'termos_condicoes',
      title: 'Termos e Condições',
      sections: [
        {
          title: 'Declarações Obrigatórias',
          fields: [
            {
              type: 'checkbox',
              name: 'declaroVerdade',
              label: 'DECLARO que as informações prestadas neste requerimento são verdadeiras e estou ciente de que a falsidade ideológica constitui crime previsto no Código Penal, sujeitando-me às penalidades da lei.',
              required: true
            },
            {
              type: 'checkbox',
              name: 'declaroPerda',
              label: 'DECLARO que estou ciente de que a 2ª via será concedida mediante pagamento da taxa correspondente, conforme tabela vigente.',
              required: true,
              showWhen: { field: 'motivoPerda', value: 'NAO' }
            },
            {
              type: 'checkbox',
              name: 'declaroRouboFurto',
              label: 'DECLARO que estou ciente de que o Boletim de Ocorrência é obrigatório para casos de Perda, Roubo ou Furto e que sua ausência implicará no indeferimento do pedido.',
              required: true,
              showWhen: { field: 'motivoPerda', value: 'SIM' }
            },
            {
              type: 'checkbox',
              name: 'concordaLgpd',
              label: 'CONCORDO com o tratamento dos meus dados pessoais conforme a Lei Geral de Proteção de Dados (LGPD - Lei nº 13.709/2018), para as finalidades relacionadas ao processamento deste requerimento.',
              required: true
            },
            {
              type: 'checkbox',
              name: 'cienteAssinaturaDigital',
              label: 'DECLARO que o requerimento foi assinado digitalmente conforme exigido, utilizando certificado digital Gov.br ou certificado em nuvem.',
              required: true
            }
          ]
        }
      ]
    }
  ]
};

export default pedidoSegundaViaConfig;